// Shared class strings for the two insight pill types (EnumValuePills + SegmentPills) so their visuals
// can't drift. Each pill is a `role="option"` chip — a 24px rounded badge with a transparent fill that carries
// the L1-family (Input/Button) interaction states: a grey border that darkens + greys-glows on hover, and a
// brand-blue border/text when selected with a blue glow on hover. Divider-split count on the right.

// `disabled:opacity-50` gives a disabled pill the same dimmed look the shared Button applies to itself, so a
// disabled insight panel reads as inactive alongside the disabled row buttons.
// `whitespace-pre` is load-bearing, not cosmetic: `foldKey` trims, so `'pro'` and `'pro '` are ONE fold —
// and once a rule selects just one of them the other is offered as its own chip. Collapsed by HTML they
// would render as two identical "pro" chips with nothing to tell them apart.
export const PILL_BASE =
  'focus-ring flex h-6 shrink-0 cursor-pointer items-center gap-1.5 rounded border px-2.5 py-0.5 text-sm whitespace-pre transition-[color,box-shadow,border-color] disabled:pointer-events-none disabled:opacity-50';
// Selected: brand border + text, no fill; blue glow on hover (border stays brand).
export const PILL_SELECTED = 'border-primary font-medium text-primary hover:shadow-primary';
// Unselected: grey border, no fill; darker border + grey glow on hover (no fill change).
export const PILL_UNSELECTED = 'border-grey-75 text-foreground hover:border-grey-200 hover:shadow-secondary';

// The trailing count, split from the label by a left divider.
export const PILL_COUNT = 'border-l pl-1.5 font-mono text-[0.6875rem]';
export const PILL_COUNT_SELECTED = 'border-primary/30 text-primary';
export const PILL_COUNT_UNSELECTED = 'border-border text-muted-foreground';
